import React from "react";
import { Link, useNavigate } from "react-router-dom";
import { MdContentCopy } from "react-icons/md";
import { BsTwitter } from "react-icons/bs";
import { BsYoutube } from "react-icons/bs";
import { AiFillInstagram } from "react-icons/ai";
import { BsLinkedin } from "react-icons/bs";
import { BsFillShareFill } from "react-icons/bs";
import { BsBookmarkHeartFill } from "react-icons/bs";
import { BsCameraFill } from "react-icons/bs";
import useAuth from "../../Hooks/useAuth";

const ProfileCard = ({ data }) => {
  const navigate = useNavigate()
  const {setIsLogin,isLogin,showDummyImage} = useAuth()
  const openInNewTab = (url) => {
    window.open(url, "_blank", "noopener,noreferrer");
  };
  const logout = () => {
    localStorage.setItem('credentials', JSON.stringify({}));
    setIsLogin(!isLogin);
    navigate("/signin");
  }
  const location = window.location.href;
  return (
    <div className="profil-card">
      <div className="profile-meta">
        <div className="profile-pic">
          <img
            src={require(`${process.env.REACT_APP_USER_IMAGE}${data?.profileImg}`)}
            alt=""
            onError={({currentTarget},imageSize='105X105')=>showDummyImage({currentTarget},imageSize)}
          />
          {
            location.includes("edit-profile") && <div className="change-profile-pic">
            <input className="change-profile-pic-file" type="file" />
            <div className="change-profile-pic-btn">
              <BsCameraFill />
            </div>
          </div>
          }
          
        </div>
        <h4 className="profile-name">{data?.profileName} </h4>
        <span className="copy-email">
          {data?.userId} <MdContentCopy className="copy-icon" />
        </span>
        <p className="profile-meta-text">{data?.description}</p>
        <div className="profile-follow">
          <button className="profile-follow-btn">Follow</button>
        </div>
        <div className="profile-info">
          <div className="profile-info-item">
            <span>{data?.creation}</span>
            <small>Creations</small>
          </div>
          <div className="profile-info-item">
            <span>{data?.following}</span>
            <small>Following</small>
          </div>
          <div className="profile-info-item">
            <span>{data?.follower}</span>
            <small>Followers</small>
          </div>
        </div>
        <div className="profile-social">
          <Link to={"/edit-profile"} className="profile-following-btn">
            Edit Profile
          </Link>
          <Link
            to="#"
            className="profile-social-link"
            onClick={() => openInNewTab('https://twitter.com/')}
          >
            <BsTwitter />
          </Link>
          <Link
            to="#"
            className="profile-social-link"
            onClick={() => openInNewTab('https://www.youtube.com/')}
          >
            <BsYoutube />
          </Link>
          <Link
            to="#"
            className="profile-social-link"
            onClick={() => openInNewTab('https://www.instagram.com/')}
          >
            <AiFillInstagram />
          </Link>
          <Link
            to="#"
            className="profile-social-link"
            onClick={() => openInNewTab('https://www.linkedin.com/')}
          >
            <BsLinkedin />
          </Link>
        </div>
        <p className="member">MEMBER SINCE: DECEMBER 23, 2021</p>
        <div className="share-profile">
          <button>
            <BsFillShareFill />
          </button>
          <button>
            <BsBookmarkHeartFill />
          </button>
        </div>
        <div className="profile-follow">
          <button onClick={logout} className="profile-follow-btn">Logout</button>
        </div>
      </div>
    </div>
  );
};

export default ProfileCard;
